export const extendInventoryMethods = (baseInventoryObject) => {
  return {
    ...baseInventoryObject,
    fetch: {
      ...baseInventoryObject.fetch,
      /**
       * Extends from the core inventory fetch method, adding the correct
       * encoding to the product IDs. See inventory.fetch.byProductIds in core
       * logic file for main fetching logic.
       * @param {Array} productIdsArray Array of product IDs to fetch inventory of
       * @returns {Object} Product ID key > Inventory value object
       */
      byProductIds: async (productIdsArray) => {
        if (!productIdsArray || !productIdsArray.length) return {}

        const productsInventory =
          await baseInventoryObject.fetch.byProductIds(productIdsArray)

        if (!productsInventory) return {}

        return Object.keys(productsInventory).reduce(
          (allProductIds, currentId) => {
            const decodedGIDParts = currentId.split('/')
            const encodedShopifyId = decodedGIDParts[decodedGIDParts.length - 1]

            return {
              ...allProductIds,
              [encodedShopifyId]: productsInventory[currentId],
            }
          },
          {},
        )
      },
    },
  }
}
